import { createAction } from 'redux-actions';
export const setPassengers = createAction('SET_PASSENGERS');
